<template>
    <div class="move-stage-config">
        <div class="config-field">
            <label>Hedef Stage</label>
            <a-select
                v-model="localConfig.stageId"
                placeholder="Stage seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="stage in workflowStages"
                    :key="stage._id"
                    :value="stage._id"
                >
                    {{ stage.name }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "MoveStageConfig",
    props: {
        value: {
            type: Object,
            required: true
        },
        workflowId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            localConfig: { stageId: null }
        };
    },
    computed: {
        ...mapState({
            workflows: state => state.tasks.workflows || []
        }),
        currentWorkflow() {
            return this.workflows.find(w => w._id === this.workflowId);
        },
        workflowStages() {
            if (!this.currentWorkflow || !this.currentWorkflow.pipeline) return [];
            // Pipeline direkt stage object'lerini içeriyor (EditorTask.vue'daki gibi)
            return this.currentWorkflow.pipeline;
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.move-stage-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }
}
</style>
